import React from 'react';
import Header from 'Components/Header/Header';
import { useContext, useEffect, useState } from 'react';
import { Context } from 'Context/Context';
import AttorneyDashboardTeamup from './AttorneyDashboardTeamup';
import { getTeamupListApi } from 'Constants';
import { CaseListLayout } from 'Components/Professional/Cases/CaseListUI';
import { FilterBar } from 'Components/Professional/Cases/CaseFilters';

// Funder Teamup (header menu) — Connection requests · Funder connections
// (funders see the attorney side: Attorney requests · Attorney connections)
function AttorneyDashboard({attorney}) {
    const {userDetails, makeApiCallFunc, filters} = useContext(Context);
    const [innerPanel, setInnerPanel] = useState(0);
    const [offset, setOffset] = useState(0);
    const userInfo = attorney ? attorney?.userId : userDetails;
    const [updateComp, setUpdateComp] = useState(false);
    // pending connection requests need an answer - dot on that tab while any are waiting
    const [pendingCount, setPendingCount] = useState(0);
    useEffect(() => {
        if (!userInfo?._id) return;
        makeApiCallFunc(
            getTeamupListApi,
            { userId: userInfo?._id, isFunder: userInfo?.isUserFunder, skip: 0, limit: 1, filters, inviteStatus: 0 },
            ({data}) => setPendingCount(Number(data?.totalCount) || 0),
            () => {},
            null, true
        );
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userInfo?._id, filters, updateComp]);
    const builder = () => {
        switch(innerPanel)
        {
            case 0 :
                return <div className='flex flex-col w-full'> 
                <AttorneyDashboardTeamup userInfo={userInfo} offset={offset} setOffset={setOffset} updateComp={updateComp} setUpdateComp={setUpdateComp} attorney={attorney} innerPanel={innerPanel} />
                </div>
            case 1 : 
                return <div className='flex flex-col w-full'> 
                    <AttorneyDashboardTeamup userInfo={userInfo} offset={offset} setOffset={setOffset} updateComp={updateComp} setUpdateComp={setUpdateComp} attorney={attorney} innerPanel={innerPanel}
                    isConnectedList ={true}
                    />
                    </div>
            default :
                return <></>
        }
    }
        
    const funder = !!userInfo?.isUserFunder;
    const railItems = [
        { key: 0, label: funder ? 'Attorney requests' : 'Connection requests', icon: 'connectionRequests', dot: pendingCount > 0 },
        { key: 1, label: funder ? 'Attorney connections' : 'Funder connections', icon: 'funderConnections' },
    ];
    const countFor = (draft) => ({
        url: getTeamupListApi,
        body: { userId: userInfo?._id, isFunder: userInfo?.isUserFunder, skip: 0, limit: 1, filters: draft, inviteStatus: innerPanel === 1 ? 1 : 0 },
        pick: (d) => (d?.totalCount || 0),
    });
    return (
    <>
    {attorney ? null : <Header caseList={true} />}
    {/* the page sits in Layout's 6-column grid - span all of it */}
    <div className='col-span-6 w-full min-w-0'>
    <CaseListLayout
        attorney={attorney}
        sectionKey={attorney ? '6' : '4'}
        railItems={railItems}
        activeKey={innerPanel}
        onSelect={(k) => { setOffset(0); setInnerPanel(k); }}
        setUpdateComp={setUpdateComp}
    >
        <FilterBar attorney={attorney} setUpdateComp={setUpdateComp} countFor={countFor}/>
        {builder()}
    </CaseListLayout>
    </div>
    </>
  )
}

export default AttorneyDashboard
